package data.models

import kotlinx.serialization.Serializable

@Serializable
data class RequestResetPasswordData(
    val email: String,
)


